/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Reviews_EmptyInputs */

const en_directory_detail_reviews_empty = /** @type {(inputs: Directory_Detail_Reviews_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No reviews yet. Be the first to rate this product!`)
};

const zh_directory_detail_reviews_empty = /** @type {(inputs: Directory_Detail_Reviews_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有评价。成为第一个评价的人！`)
};

/**
* | output |
* | --- |
* | "No reviews yet. Be the first to rate this product!" |
*
* @param {Directory_Detail_Reviews_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_reviews_empty = /** @type {((inputs?: Directory_Detail_Reviews_EmptyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Reviews_EmptyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_reviews_empty(inputs)
	return zh_directory_detail_reviews_empty(inputs)
});
export { directory_detail_reviews_empty as "directory.detail.reviews_empty" }